import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
//引入axios插件
import axios from "axios";
Vue.prototype.$axios = axios;


import Vant from 'vant';
import 'vant/lib/index.css';
import './common/font/font.css';

Vue.use(Vant);

import { Lazyload } from 'vant';
Vue.use(Lazyload);

import { Toast } from 'vant';
Vue.use(Toast);

import { Dialog } from 'vant';
Vue.use(Dialog);
import { DatetimePicker } from 'vant';

Vue.use(DatetimePicker);


import VanFieldSelectPicker from './components/VanFieldSelectPicker.vue'
Vue.component('VanFieldSelectPicker',VanFieldSelectPicker)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.prototype.$bus = new Vue();



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
